export default __webpack_public_path__ + "static/media/safari-settings-steps-ios-aa-ar.0b381ca5.png";